import { keyBy } from 'lodash-es'

export const useTeams = defineStore('teams', () => {
  const store = useBaseStore('teams')

  const user = useUser()
  // Note: team members store watches this store's selectedTeam
  const config = useRuntimeConfig()
  const isFeatureEnabled = computed(() => config.public.TEAMS_DASHBOARD_ENABLED === 'true')

  const partner = ref(null)
  const isOnboardingComplete = computed(() => partner.value?.onboarding_status)

  const loadingTeam = ref(true)
  const current = ref(null)
  const data = ref({})
  const vouchers = ref([])

  watch([store.list, data], () => {
    if (current.value) {
      current.value = data.value[current.value?.id]
    }
  })

  const { $api } = useNuxtApp()

  async function get () {
    await store.getAll()
    data.value = keyBy(store.list.value, 'id')
    loadingTeam.value = false
  }

  async function getDanglingVouchers () {
    try {
      return await $api.get('/voucher-combos')
    } catch (e) {
      console.error(e)
    }
  }

  async function getPartnerVouchers () {
    try {
      return await $api.get('/team-partner-vouchers')
    } catch (e) {
      console.error(e)
    }
  }

  async function assignVoucher (code, params) {
    return await $api.post(`/vouchers/${code}/send`, params)
  }

  async function assignVoucherToTeam (teamId, voucherCode) {
    return await $api.post(`/teams/${teamId}/voucher-combos/assign-to-team`, {
      voucher_combo_code: voucherCode
    })
  }

  async function getUserPartners () {
    try {
      if (!user.isPartner) return

      const partnersResp = await $api.get('/partners')
      partner.value = partnersResp?.data
    } catch (e) {
      console.error('Error loading partners:', e)
    }
  }

  // function fillSelectedTeamUsers (team) {
  //   const ids = []
  //   const uniqueUsers = []

  //   // if (!team.data?.users) {
  //   //   return
  //   // }

  //   // team.data.users.forEach((_user) => {
  //   //   if (!ids.includes(_user.id)) {
  //   //     ids.push(_user.id)
  //   //     uniqueUsers.push(_user)
  //   //   }
  //   // })
  // }
  async function selectTeam (id) {
    try {
      loadingTeam.value = true

      if (id) {
        // update selected team; teamMembers store will react to this change
        current.value = data.value[id]

        // if (selectedTeam.value) {
        //   const invites = await getTeamInvitiations(selectedTeam.value?.id)
        //   selectedTeamInvites.value = invites?.data?.filter(i => i.status === 'pending').map((i) => ({
        //     ...i,
        //     name: `${i.first_name} ${i.last_name}`,
        //     roles: i.roles.map((r) => r.fields?.role)
        //   })) || []
        // }

        // fillSelectedTeamUsers(team)
      }
    } catch (e) {
      console.error(e)
    } finally {
      loadingTeam.value = false
    }
  }

  // teamMembers store is responsible for syncing members based on selectedTeam

  async function getTeam (id) {
    const response = await $api.get(`/teams/${id}`)

    current.value = response.data

    return response.data
  }

  async function create (payload, headers = {}) {
    return await $api.post('/teams', payload, headers)
  }

  async function update (id, payload, headers = {}) {
    return await $api.post(`/teams/${id}?_method=PUT`, payload, headers)
  }

  async function deleteTeam (teamId) {
    return await $api.delete(`/teams/${teamId}`)
  }

  async function addMember (teamId, member) {
    const response = await $api.post(`/teams/${teamId}/invite`, member)
    // Fetch fresh team data to update cache
    await getTeam(teamId)
    return response
  }

  async function updateUserRole (teamId, payload) {
    return await $api.put(`/teams/${teamId}/users/role`, payload)
  }

  async function completeOnboading (teamId) {
    return await $api.post(`/teams/${teamId}/onboarding/complete`, {
      onboarding_status: true
    })
  }

  async function archiveTeam (teamId) {
    return await $api.post(`/teams/${teamId}/archive`)
  }

  async function unarchiveTeam (teamId) {
    return await $api.post(`/teams/${teamId}/unarchive`)
  }

  async function getTeamStats (teamId) {
    return await $api.get(`/teams/${teamId}/stats`)
  }

  async function getTeamInvitiations (teamId) {
    return await $api.get(`/teams/${teamId}/invitations`)
  }

  async function sendVoucherInvite (voucherCode, email) {
    return await $api.post(`/vouchers/${voucherCode}/send`, {
      email
    })
  }

  async function joinTeam (token) {
    return await $api.post('join-team', {
      token
    })
  }

  return {
    ...store,
    data,
    vouchers,
    partner,
    get,
    getTeamStats,
    getTeamInvitiations,
    sendVoucherInvite,
    current,
    selectTeam,
    loadingTeam,
    getUserPartners,
    getPartnerVouchers,
    getDanglingVouchers,
    getTeam,
    assignVoucher,
    assignVoucherToTeam,
    isOnboardingComplete,
    create,
    update,
    deleteTeam,
    addMember,
    updateUserRole,
    completeOnboading,
    archiveTeam,
    unarchiveTeam,
    isFeatureEnabled,
    joinTeam
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useVouchers, import.meta.hot))
}
